import React, { useState, useContext, useEffect, useRef } from "react";
// import { getAuth, updateProfile, signOut } from "firebase/auth";
// import { db } from "../Firebase/FirebaseConfig";
// import {
//   ref,
//   uploadBytesResumable,
//   getDownloadURL,
//   getStorage,
// } from "firebase/storage";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Fade } from "react-reveal";
// import toast, { Toaster } from "react-hot-toast";
import logo from "../../assets/images/mayaLogo.png";

import { AuthContext } from "../../Context/UserContext";
import WelcomePageBanner from "../../assets/images/WelcomePageBanner.png";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { CiCirclePlus } from "react-icons/ci";
import Navbar from "../../components/Header/Navbar";
import axiosClient from "../../axios-client";

function Subscription() {
    const { User } = useContext(AuthContext);
    const [subscriptions, setSubscriptions] = useState([]);
    const [promoCode, setPromoCode] = useState();

    const navigate = useNavigate();


    const location = useLocation()
    useEffect(() => {
        const fetchSubscriptions = async () => {
            try {
                const response = await axiosClient.get("subscriptions/"); // Replace with your actual API endpoint
                setSubscriptions(response.data);
            } catch (error) {
                // console.error("Error fetching subscriptions:", error);
            }
        };

        fetchSubscriptions();
    }, []);

    // const handleSubscription = async (subscription) => {
    //     if (!promoCode) {
    //         navigate("/paiement", {
    //             state: {
    //                 promoCode: "",
    //                 price: subscription.price,
    //                 subscriptionType: subscription.type,
    //                 subscriptionId: subscription.id,
    //             },
    //         });
    //         return;
    //     }

    //     try {
    //         setLoading(true);
    //         setError(null);

    //         const stripeResponse = await axiosClient.post('check-stripe-promo/', { promoCode });
    //         console.log(stripeResponse);

    //         if (stripeResponse.data && stripeResponse.data.discount) {
    //             const stripeDiscount = stripeResponse.data.discount;
    //             const calculatedPrice = price - (price * stripeDiscount / 100);
    //             setFinalPrice(calculatedPrice.toFixed(2));
    //             setDiscount(stripeResponse.data.discount)
    //             return;
    //         }

    //         try {
    //             const response = await axiosClient.get(`promocodes/name/${promoCode}/`);
    //             let promo = response.data;
    //             console.log(promo);

    //             if (promo && promo.discount) {
    //                 const discount = promo.discount;
    //                 const calculatedPrice = price - (price * discount / 100);
    //                 setFinalPrice(calculatedPrice.toFixed(2));
    //                 setDiscount(promo.discount)
    //             } else {
    //                 setFinalPrice(price);
    //             }
    //         } catch (err) {
    //             setError("Failed to fetch promo details from the database.");
    //             setFinalPrice(price);
    //             if (!toast.isActive("promo error")) {
    //                 toast.warning(`Le code promo saisi n'est pas pris en charge car il est invalide ou expiré.`, {
    //                     toastId: 'promo error',
    //                     position: "top-right",
    //                     autoClose: 3000,
    //                 });
    //             }
    //         }
    //     } catch (err) {
    //         setError("Failed to verify promo code with Stripe.");
    //         setFinalPrice(price);
    //         if (!toast.isActive("promo error")) {
    //             toast.warning(`Le code promo saisi n'est pas pris en charge car il est invalide ou expiré.`, {
    //                 toastId: 'promo error',
    //                 position: "top-right",
    //                 autoClose: 3000,
    //             });
    //         }
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    return (
        <div>


            <div
                className="flex min-h-screen justify-center items-center"
                style={{
                    background: `url(${WelcomePageBanner})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <Navbar></Navbar>
                {/* {isMyListUpdated ? (
          <Toaster
            toastOptions={{
              style: {
                padding: "1.5rem",
                backgroundColor: "##f4fff4",
                borderLeft: "6px solid green",
              },
            }}
          />
        ) : null} */}
                <div className="mt-16 p-5 md:p-12 rounded-md">
                    {/* <div className="py-5 flex justify-center items-center ">
            <img
              className="h-10 cursor-pointer w-18"
              src={logo}
              alt="NETFLIX"
            />
          </div>
          <h1 className=" text-center text-xl text-white  mb-4 md:mb-8">
           Abonnez-vous!
          </h1> */}

                    <div className="relative  flex flex-col md:flex-row gap-5 justify-between items-stretch min-h-[500px] mb-4 md:mb-8">
                        {subscriptions.map((subscription) => (
                            <div key={subscription.id} className="w-80 p-5 bg-white text-center rounded-2xl shadow-xl flex flex-col justify-between">
                                <div>
                                    <div className="h-[130px]">
                                        <h1 className="text-black mb-2 font-semibold text-2xl">
                                            {subscription.name}
                                        </h1>
                                        <h5>{subscription.description}</h5>
                                        <p className="pt-2 tracking-wide">
                                            <span className="text-orange-400 align-top">€ </span>
                                            <span className="text-3xl text-orange-400 font-semibold">{subscription.price}</span>
                                            <span className="text-orange-400 font-medium"> / {subscription.type === "ANNUEL" ? "Année" : "Mois"}</span>
                                        </p>
                                    </div>

                                    <hr className="mt-4 border-1" />
                                    <div className="pt-5 flex flex-col justify-center items-center">
                                        {subscription.features.map((feature, index) => (
                                            <p key={index} className="text-sm font-semibold text-black text-left pt-3">
                                                <span>{feature}</span>
                                            </p>
                                        ))}
                                    </div>
                                </div>
                                <div className="gap-3 flex flex-col mt-8">
                                    <input
                                        type="text"
                                        onChange={(e) => setPromoCode(e.target.value)}
                                        // value={promoCode}
                                        name="promoCode"
                                        id="promoCode"
                                        className="bg-gray-50 sm:text-sm rounded-lg w-full block p-3.5 placeholder:text-gray border border-gray-300 focus:outline-none focus:ring-1 focus:ring-gray-100"
                                        placeholder="Code promo"
                                        required
                                    />

                                    <button onClick={()=>
                                        navigate("/paiement",{
                                            state: {
                                                promoCode: promoCode,
                                                price:subscription.price,
                                                subscriptionType:subscription.type,
                                                subscriptionId:subscription.id,
                                              },
                                        })
                                    } className="w-full bg-orange-300 hover:bg-orange-400 transition duration-500 ease-in-out shadow-2xl flex justify-center items-center my-3 py-4 font-semibold text-white rounded-xl text-center">
                                            <span className="font-medium">S'abonner</span>
                                        </button>
                                    {/* <button onClick={() =>
                                        handleSubscription(subscription)
                                    } className="w-full bg-orange-300 hover:bg-orange-400 transition duration-500 ease-in-out shadow-2xl flex justify-center items-center my-3 py-4 font-semibold text-white rounded-xl text-center">
                                        <span className="font-medium">S'abonner</span>
                                    </button> */}
                                </div>
                            </div>
                        ))}
                    </div>

                </div>
            </div>
        </div>
    );
}

export default Subscription;
